module.exports = __webpack_public_path__ + "static/media/WW-Portfolio_Website_Pages-02-sm.3516e9ca.jpg";